import React from 'react';
import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';

function InformationIcon() {
  const navigate = useNavigate();

  const { InformationPages } =
    useSelector(state => state.resource?.getInformationPage?.detail) || [];

  const count =
    (InformationPages && InformationPages.filter(item => !item.IsRead).length) || 0;

  return (
    <div className="tv-information-icon__container">
      <button
        type="button"
        className="tv-information-icon__button"
        onClick={() => navigate('/information')}
        aria-label="Aktuellt"
        tabIndex={0}
      >
        <i
          className={`fa fa-info ${count > 0 ? 'tv-information-icon-active' : ''}`}
          aria-hidden="true"
        />
      </button>
      {count > 0 && <div className="tv-information-icon__count">{count}</div>}
    </div>
  );
}

export default InformationIcon;
